export const highPriorityGroupLabel = "RyuRl";
export const lowPriorityGroupLabel = "bIuHwb";
export const normalPriorityGroupLabel = "URmbIe";
export default {highPriorityGroupLabel,lowPriorityGroupLabel,normalPriorityGroupLabel};